import React from "react";
import coeImg from "../../assets/images/principal_bmk.jpg";
export default function DeanEng() {
  return (
    <>
      <section
        className="section"
        style={{
          position: "relative",
          top: "185px",
          marginBottom: "20vh",
          marginTop: "10vh",
          padding: "2rem",
        }}
      >
        <div className="centered-image">
          <div>
            <h1 style={{ textAlign: "center" }}>
              Dean Engineering and Technology
            </h1>
            <h2 style={{ textAlign: "center" }}>Dr. B. Manoj Kumar</h2>
          </div>
          <div>
            <img
              src={coeImg}
              alt="Controller of Examinations Dr. Shiddayya S Shirur"
              style={{
                width: "100%",
                height: "100%",
                minWidth: "300px",
                minHeight: "200px",
                maxWidth: "600px",
                maxHeight: "400px",
              }}
            />
          </div>
        </div>
        <br />
        <br />
        <p
          className=""
          style={{
            textAlign: "justify",
            fontSize: "1.2em",
          }}
        >
          Being recognized as one of the best Technical Institutions, JSS
          Academy of Technical Education, Noida (JSSATEN) is adopting cautiously
          to the changing demands of technical manpower at global level. The
          Academy envisions to become an Institution of Excellence in imparting
          quality outcome based education that empowers young generation with
          knowledge, skills, research aptitude, ethics and moral values. The
          Institutions has been making efforts to strictly implement OBE by
          preparing the Faculty members to a system, where they measure the
          progress and competencies of the student as they go through a course
          in each Semester. 21st century belongs to highly skilled technical
          manpower with exceptional knowledge and creative thinking abilities.
          JSSATE, Noida has put all necessary steps to impart knowledge and
          skills using modern teaching-learning methods. JSSATEN has attracted
          more than 83 industries during the year 2014. It strives to increase
          the numbers in the coming years. A Centre for Innovation and Design
          caters to all the students to undertake interdisciplinary
          collaborative projects. The Institution encourages International
          Internships Programs with Universities in USA and France. The
          Institution also provides ample opportunities for extracurricular
          activities. We wish that JSSATEN would be your dream Institutions to
          fulfil your futuristic aspiration.
          <br />
          <br />
          Dr. B. Manoj Kumar
          <br />
          Dean Engineering and TechnologyController of Examination
          <br />
          JSS University, Noida
        </p>
      </section>
    </>
  );
}
